/* Dashboard Layout - Remove header completely */
.container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: #F7F9FC;
}

.content {
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
}

/* Remove all header styles and add page title styles */
.pageTitle {
  font-size: 28px;
  font-weight: 600;
  color: #2D3748;
  margin-bottom: 0.5rem;
}

.welcomeText {
  color: #718096;
  margin-bottom: 2rem;
  font-size: 16px;
}

/* Dashboard sections */
.dashboardSection {
  margin-bottom: 2rem;
}

.sectionTitle {
  font-size: 20px;
  font-weight: 600;
  color: #2D3748;
  margin-bottom: 8px;
}

.sectionDescription {
  color: #718096;
  margin-bottom: 1.5rem;
  font-size: 16px;
}

/* Restaurant Cards - updated with white background */
.restaurantGrid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 2rem;
}

.restaurantCard {
  background: white; /* White background */
  color: #2D3748; /* Dark text for better contrast */
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 2rem 1.5rem;
  border: 1px solid #E2E8F0; /* Light border */
  display: flex;
  flex-direction: column;
  height: 100%;
  transition: all 0.2s ease;
}

.restaurantCard:hover {
  transform: translateY(-4px);
  box-shadow: 0 4px 12px rgba(99, 91, 255, 0.15);
}

.restaurantName {
  font-size: 20px;
  font-weight: 600;
  color: #2D3748; /* Dark text */
  margin-bottom: 8px;
}

.restaurantDesc {
  color: #718096; /* Medium gray text */
  font-size: 15px;
  margin-bottom: 24px;
  line-height: 1.6;
  flex-grow: 1;
}

/* Card actions */
.cardActions {
  margin-top: auto;
  padding-top: 16px;
  margin-bottom: 16px;
}

.viewAnalyticsButton {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background-color: #EBF4FF;
  color: #635BFF;
  border: none;
  padding: 10px 16px;
  border-radius: 6px;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  width: 100%;
  transition: all 0.2s ease;
}

.viewAnalyticsButton:hover {
  background-color: #D9E8FF;
  color: #4A32C3;
}

/* Action buttons */
.actionButtons {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

/* Buttons - updated to match other pages */
.primaryButton {
  background-color: #635BFF; /* Purple like other primary buttons */
  color: white;
  border: none;
  padding: 10px 16px;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 500;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.primaryButton:hover {
  background-color: #574ce0; /* Darker purple on hover */
  transform: translateY(-2px);
}

/* Button styles for each action */
.editButton {
  background-color: #EDF2F7; /* Light gray background */
  color: #4A5568; /* Dark gray text */
  border: none;
  padding: 10px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.editButton:hover {
  background-color: #E2E8F0;
}

.qrButton {
  background-color: #805AD5; /* Purple */
  color: white;
  border: none;
  padding: 10px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.qrButton:hover {
  background-color: #6B46C1;
}

.ordersButton {
  background-color: #3182CE; /* Blue */
  color: white;
  border: none;
  padding: 10px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.ordersButton:hover {
  background-color: #2B6CB0;
}

.analyticsButton {
  background-color: #38A169; /* Green */
  color: white;
  border: none;
  padding: 10px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.analyticsButton:hover {
  background-color: #2F855A;
}

.deleteButton {
  background-color: rgba(245, 101, 101, 0.1); /* Light red */
  color: #E53E3E; /* Red text */
  border: 1px solid #E53E3E;
  padding: 10px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  grid-column: span 2; /* Make delete button span both columns */
}

.deleteButton:hover {
  background-color: rgba(245, 101, 101, 0.2); /* Slightly darker red */
}

/* Add restaurant button */
.addButton {
  position: fixed;
  right: 2rem;
  bottom: 2rem;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: #635BFF; /* Purple */
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(99, 91, 255, 0.3);
  cursor: pointer;
  border: none;
  transition: all 0.3s ease;
  z-index: 10;
  font-size: 24px;
}

.addButton:hover {
  transform: scale(1.1) rotate(90deg);
  background-color: #574ce0; /* Darker purple on hover */
}

.buttonIcon {
  margin-right: 6px;
}

/* Loading state */
.loadingContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 60vh;
  padding: 0 20px;
}

.loadingSpinner {
  width: 40px;
  height: 40px;
  border: 3px solid #E2E8F0; /* Light gray border */
  border-top-color: #635BFF; /* Purple spinner */
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 16px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Info callout for Stripe setup */
.infoCallout {
  padding: 1.5rem;
  background-color: rgba(99, 91, 255, 0.05);
  border-left: 4px solid #635BFF;
  border-radius: 6px;
  margin-bottom: 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.infoCalloutText {
  color: #4A5568;
  margin: 0;
}

/* Empty state */
.emptyState {
  background-color: white;
  border-radius: 12px;
  padding: 40px;
  text-align: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.emptyState h3 {
  margin-bottom: 8px;
  color: #2D3748;
  font-size: 18px;
}

.emptyState p {
  color: #718096;
  margin-bottom: 24px;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .headerRow {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  
  .headerButtons {
    width: 100%;
  }
  
  .restaurantGrid {
    grid-template-columns: 1fr;
  }
  
  .infoCallout {
    flex-direction: column;
    gap: 16px;
    text-align: center;
  }
  
  .actionButtons {
    grid-template-columns: 1fr;
  }
  
  .deleteButton {
    grid-column: auto;
  }
}
/* Restaurant logo section */
.restaurantLogoSection {
  display: flex;
  justify-content: center;
  margin-bottom: 16px;
}

.logoThumbnail {
  position: relative;
  width: 80px;
  height: 80px;
  border-radius: 12px;
  overflow: hidden;
  border: 2px solid #E2E8F0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #F7FAFC;
}

.logoImage {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.logoPlaceholder {
  color: #CBD5E0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.logoEditButton {
  position: absolute;
  bottom: -4px;
  right: -4px;
  background-color: #635BFF;
  color: white;
  border: none;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
}

.logoEditButton:hover {
  background-color: #574ce0;
  transform: scale(1.1);
}

/* Logo upload modal */
.logoModal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.logoModalContent {
  background-color: white;
  padding: 24px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  max-width: 400px;
  width: 90%;
}

.logoModalContent h3 {
  margin: 0 0 16px 0;
  color: #2D3748;
}

.fileInput {
  width: 100%;
  padding: 8px;
  border: 2px dashed #CBD5E0;
  border-radius: 6px;
  margin-bottom: 16px;
  cursor: pointer;
}

.fileInput:hover {
  border-color: #635BFF;
}

.logoModalActions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.cancelButton {
  background-color: #E2E8F0;
  color: #4A5568;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.cancelButton:hover {
  background-color: #CBD5E0;
}

/* Update restaurant card to accommodate logo */
.restaurantCard {
  background: white;
  color: #2D3748;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 1.5rem;
  border: 1px solid #E2E8F0;
  display: flex;
  flex-direction: column;
  height: 100%;
  transition: all 0.2s ease;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .logoThumbnail {
    width: 60px;
    height: 60px;
  }
  
  .logoEditButton {
    width: 20px;
    height: 20px;
  }
}